// 🔧 category_step.js
// ✅ Purpose: Category Builder pipeline step
// ✅ Features:
// - Executes the Category Builder
// - Updates DemoContext
// - Fully block-commented for clarity and future devs

import { createPipelineStepSuccess } from "../pipeline_step";
import { buildCategoryShell } from "../../builders/category_builder";

export const createCategoryStep = () => ({
  name: "category_builder",

  label: "Category Builder",

  run: async (context) => {
    const result =
      await buildCategoryShell(context);

    return createPipelineStepSuccess({
      step: "category_builder",

      label: "Category Builder",

      created:
        result?.createdCount ||
        result?.plannedCount ||
        0,

      message: result?.message,

      metadata: result,

      startedAt: context.startedAt,
    });
  },

  afterSuccess: ({
    result,
    sharedContext,
  }) => {
    sharedContext.categoryResult =
      result?.metadata || null;

    sharedContext.categories =
      result?.metadata?.createdCategories ||
      [];
  },
});